import api from '../api';
import { QueryFilters, QueryResult } from '../types';

export default {
  findAll(customerId: string, filters: QueryFilters): Promise<QueryResult> {
    return api
      .get(`customers/${customerId}/payments`, { params: filters })
      .then(response => response.data);
  },
};
